export default __webpack_public_path__ + "static/LookoutMountain_HamiltonCo_Rock-City_NathanLambrecht_01169-f1c8a40d2ff1d3b14eb1ca5d80a6ba6c.jpg";